import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { SNOWALERT_VIEWTYPE } from 'src/app/main/side-bar/snow-watch/snow-dashboard/snow-map-constants';
import { ToastrService } from 'ngx-toastr';
import { DatepickerComponent } from 'src/app/utils/datepicker/datepicker.component';
import { UtilsSharedModule } from 'src/app/main/shared/utils/utils/utils.module';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';

@Component({
  selector: 'app-snow-sidebar',
  templateUrl: './snow-sidebar.component.html',
  styleUrls: ['./snow-sidebar.component.scss']
})

export class SnowSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  selected: any = 'snow';
  selectedSource: any = 'ECMWF';
  sourceOptions: any = {
    'ECMWF': 'ecmwf_1hr',
    'Snow Forecast Vassar': 'ecmwf_1hr_snow_accumulation'
  };
  modalRef: any;

  sourceMapping = {
    ecmwf_1hr: 'ecmwf_1hr_hourly',
    ecmwf_1hr_snow_accumulation: 'ecmwf_1hr_snow_accumulation_hourly'
  };
  queryParams: any = {};
  isDistrictChecked: boolean = false;
  isAviationChecked: boolean = false;
  isRailwayChecked: boolean = false;
  isHighwayChecked: boolean = false;
  disableAviation: boolean = true;
  disableRailway: boolean = true;
  disableHighway: boolean = true;
  selectedSnowView: any;
  @ViewChild(DatepickerComponent, { static: false }) datepicker: DatepickerComponent;
  minDate: any;
  maxDate: any;
  sDate: object = { required: true };
  eDate: object = { required: true };
  format: object = { required: true };
  validation: boolean[] = new Array(5).fill(true);
  selectedFormat: any = 'DAILY';
  formatOptions: any = { 'Daily': 'DAILY', 'Hourly': 'HOURLY' };

  subscriptions: any = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private utilsShared: UtilsSharedModule,
    private gisMapComp: GisDimsMapComponent
  ) { }

ngOnInit() {
  this.route.queryParams.subscribe(params => {
    this.queryParams = params;
    this.selectedSnowView = params['snowView'] || 'observed';
    this.selectedSource = params['source'] || 'ecmwf_1hr';
    this.selectedFormat = params['format'] || 'HOURLY';
    if (!params['snowView']) {
      this.router.navigate(
        ['/snowwatch/snow/akbm'],
        {
          queryParams: {
            ...params,
            snowView: 'observed',
            format: 'HOURLY',
            source: 'ecmwf_1hr'
          },
          queryParamsHandling: 'merge',
          replaceUrl: true
        }
      );
    }

    this.emitSelectedParams();

    setTimeout(() => {
      this.forceLayerInitialization();
    }, 100);

    if (this.selectedSnowView === 'observed') {
      this.resetSectorData();
    } else {
      this.setSectorLayers();
    }
  });
}


  forceLayerInitialization() {
    if (this.gisMapComp && this.gisMapComp.injectedService) {
      this.gisMapComp.injectedService['getSrcWiseLayers'](this.gisMapComp);
    }
  }

  setSectorLayers() {
    if (this.isAviationChecked) {
      this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Airport Boundary', this.isAviationChecked);
    }
    if (this.isRailwayChecked) {
      this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Railway Boundary', this.isRailwayChecked);
    }
    if (this.isHighwayChecked) {
      this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Highway Boundary', this.isHighwayChecked);
    }
  }

  setDatesFormat() {
    this.format['value'] = 'yyyyMMdd';
    this.setStartDate(this.utilsShared.getDateObjectFromModelDate('20260110'));
    this.setEndDate(this.utilsShared.getDateObjectFromModelDate('20260119'));
  }

  setStartDate(date: Date): void {
    this.sDate['value'] = date;
    this.minDate = date;
  }

  setEndDate(date: Date): void {
    this.eDate['value'] = date;
    this.maxDate = date;
  }

  ngOnChanges(change: SimpleChanges) {
  }

  onParamsChange() {
    const options = {
      ...this.queryParams,
      source: this.selectedSource,
      format: this.selectedFormat
    };
    this.router.navigate(
      ['/snowwatch/snow/akbm'],
      { queryParams: options, queryParamsHandling: 'merge' }
    );
  }

  resetInfoboxAlertView() {
    if (this.isAviationChecked) {
      this.setSnowAlertViewInInfobox(this.isAviationChecked, 'Airport Boundary');
    }
    if (this.isRailwayChecked) {
      this.setSnowAlertViewInInfobox(this.isRailwayChecked, 'Railway Boundary');
    }
    if (this.isHighwayChecked) {
      this.setSnowAlertViewInInfobox(this.isHighwayChecked, 'Highway Boundary');
    }
  }

  emitSelectedParams() {
    const params: any = {
      component: 'SNOW',
      source: 'ECMWF',
      actionType: 'filter',
      view: 'ADMIN',
      pType: 'COUNTRY',
      cType: 'STATE',
      parentLoc: 'COUNTRY',
      dashboardView: 'INDIA'
    };

    this.utils.selectedParams.next(params);
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'backgroundTransparent infocomponent'
    });
    this.modalRef.componentInstance.selected = value;
  }

  toggleDistrictLayer(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isDistrictChecked = checkbox.checked;
    this.utils.snowDistrictLayerToggle.next(this.isDistrictChecked);

    this.isAviationChecked = false;
    this.isRailwayChecked = false;
    this.isHighwayChecked = false;
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, '', this.isDistrictChecked);
    this.utils.setViewForSnowAlert.next({});
  }

  toggleAviationLayer(event, type) {
    const checkbox = event.target as HTMLInputElement;
    this.isAviationChecked = checkbox.checked;
    this.utils.snowAviationLayerToggle.next(this.isAviationChecked);

    this.isDistrictChecked = false;
    this.isRailwayChecked = false;
    this.isHighwayChecked = false;
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, type, this.isAviationChecked);
    this.setSnowAlertViewInInfobox(this.isAviationChecked, type);
  }

  toggleRailwayLayer(event, type) {
    const checkbox = event.target as HTMLInputElement;
    this.isRailwayChecked = checkbox.checked;
    this.utils.snowRailwayLayerToggle.next(this.isRailwayChecked);

    this.isAviationChecked = false;
    this.isDistrictChecked = false;
    this.isHighwayChecked = false;
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, type, this.isRailwayChecked);
    this.setSnowAlertViewInInfobox(this.isRailwayChecked, type);
  }

  toggleHighwayLayer(event, type) {
    const checkbox = event.target as HTMLInputElement;
    this.isHighwayChecked = checkbox.checked;
    this.utils.snowHighwayLayerToggle.next(this.isHighwayChecked);

    this.isAviationChecked = false;
    this.isRailwayChecked = false;
    this.isDistrictChecked = false;
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, type, this.isHighwayChecked);
    this.setSnowAlertViewInInfobox(this.isHighwayChecked, type);
  }

  setSnowAlertViewInInfobox(setView, type) {
    let infoObj: any = {};
    if (setView) {
      infoObj = {
        view: SNOWALERT_VIEWTYPE[type],
        showAlert: false
      };
    }
    this.utils.setViewForSnowAlert.next(infoObj);
  }

  ngOnDestroy() {
    this.utils.snowDistrictLayerToggle.next(null);
    this.resetSectorData();
  }

  resetSectorData() {
    this.isAviationChecked = false;
    this.isRailwayChecked = false;
    this.isHighwayChecked = false;
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Airport Boundary', this.isAviationChecked);
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Railway Boundary', this.isRailwayChecked);
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Highway Boundary', this.isHighwayChecked);
    this.utils.setViewForSnowAlert.next({});
  }

  changeSnowView(view) {
    const options = {
      ...this.queryParams,
      snowView: view,
      format: view == 'observed' ? 'HOURLY' : 'DAILY',
      source: 'ecmwf_1hr'
    };
    this.router.navigate(
      ['/snowwatch/snow/akbm'],
      { queryParams: options, queryParamsHandling: 'merge' }
    );
  }
}
